export default __webpack_public_path__ + "static/media/property_327.3399a852.png";